import { Card, Collapse, Icon } from '@blueprintjs/core'
import React, { ChangeEvent } from 'react'
import InputField from '../../../../components/shared/input-field';
import { CustomButton } from 'ui-components';
import { UrlT } from 'ui-io/company-io';

const Urls = ({ isUrlExpanded, setUrlExpanded, url, handleOnChange,handleOpenWebsite }: { isUrlExpanded: boolean, setUrlExpanded: (e: boolean) => void, url: UrlT, 	handleOnChange: (event:(ChangeEvent<HTMLInputElement>)) => void,handleOpenWebsite: (url:string) => void,
}) => {
	return (
		<>
			<CustomButton
				className='mb-sm'
				onClick={() => setUrlExpanded(!isUrlExpanded)}
				icon={isUrlExpanded ? "chevron-down" : "chevron-right"}
			>
				Url
			</CustomButton>
			<Collapse isOpen={isUrlExpanded}>
				<Card className='mb-sm'>
					{ Object.keys(url).length  && Object.entries(url).map(([key, value]) => (
							<InputField
								key={key}
								label={key.charAt(0).toUpperCase() + key.slice(1)}
								name={`companyDetail.url.${key}`}
								type="text"
								value={typeof value === "string" ? value : ""}
								onChange={handleOnChange}
								{... key=== "website" && {elem :(<Icon icon="eye-open" size={15} className="ml-xs cursor-pointer" onClick={()=>handleOpenWebsite(url?.website)} />)}}
							/>
					))}
				</Card>
			</Collapse >
		</>
	)
}

export default Urls

